// The wordmark goes home. On the home page itself, scroll to the very top
// (header included) instead of reloading.
export function bindScrollTop(link: HTMLAnchorElement, win: Window = window): void {
  link.addEventListener('click', (event) => {
    const target = new URL(link.href, win.location.href)
    if (target.pathname !== win.location.pathname) return
    event.preventDefault()
    win.history.replaceState(null, '', target.pathname)
    win.scrollTo({ top: 0, behavior: 'smooth' })
  })
}
